import { useCallback } from 'react'
import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { OpportunityApiResponse } from 'Event/interfaces'

interface EventsResponse {
  list: OpportunityApiResponse[]
}

export const useGetEvents = (): [
  (startDate: string, endDate: string) => Promise<OpportunityApiResponse[]>,
  Status<EventsResponse>,
] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<EventsResponse>()

  const getEvents = useCallback(
    async (startDate: string, endDate: string) => {
      return (
        await request({
          method: 'get',
          url: `/organizations/${organization.id}/opportunity_instances`,
          config: {
            queryStringParameters: {
              startDate,
              endDate,
              status: 'any',
            },
          },
        })
      ).list
    },
    [organization.id, request],
  )

  return [getEvents, status]
}
